export class ChatNotification{
    constructor(
        public id: string,
        public senderId: string,
        public senderName: string
    ){}
}